export default "__VITE_ASSET__C2O_z1$H__"